<template>
  <div>
    <div>
      <h2 class="th-title">Daftar Vendors</h2>
    </div>
    <a-card>
      <div class="d-flex justify-content-between">
        <a-input-search
          placeholder="Cari Nama Vendor..."
          v-model:value="search"
          style="width: 250px;"
          class="mb-3"
        />
        <router-link :to="`/vendors/create`" v-if="role !== 'dcOwner'">
          <a-button> <PlusOutlined />New Vendors </a-button>
        </router-link>
      </div>
      <div>
        <a-table
          :columns="role === 'dcOwner' ? columnsDcOwner : columns"
          :data-source="data"
          :loading="loading"
          bordered
        >
          <template #name="{ text, record }">
            <router-link :to="{ path: `/vendors/${record.id}` }" class="vb__utils__link">
              {{ text }}
            </router-link>
          </template>
          <template #action="{ record }">
            <a-button type="danger" @click="openDeleteModal(record.id)">
              <RestOutlined :style="{ color: 'white' }" />
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>

    <a-modal
      v-model:visible="isDeleteModalVisible"
      title="Konfirmasi Penghapusan"
      ok-text="Hapus"
      ok-type="danger"
      cancel-text="Batal"
      centered
      @ok="handleDelete"
      @cancel="closeDeleteModal"
    >
      <p>
        Apakah Anda yakin ingin menghapus vendor ini? Data vendor yang terpakai pada aset tidak akan
        bisa dihapus.
      </p>
    </a-modal>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { notification } from 'ant-design-vue'
import { PlusOutlined, RestOutlined } from '@ant-design/icons-vue'
import { getVendors, deleteVendor } from '../../services/axios/modc/vendor'

const columns = [
  { title: 'No', dataIndex: 'key', key: 'key' },
  { title: 'Nama Vendor', dataIndex: 'name', key: 'name', slots: { customRender: 'name' } },
  { title: 'Vendor Sign', dataIndex: 'vendorSign', key: 'vendorSign' },
  { title: 'Vendor Email', dataIndex: 'email', key: 'email' },
  { title: 'PIC', dataIndex: 'PIC', key: 'PIC' },
  { title: 'Mobile Number', dataIndex: 'mobileNumber', key: 'mobileNumber' },
  // Tambahkan kolom Action
  { title: 'Action', key: 'action', slots: { customRender: 'action' }, align: 'center' },
]
const columnsDcOwner = [
  { title: 'No', dataIndex: 'key', key: 'key' },
  { title: 'Nama Vendor', dataIndex: 'name', key: 'name', slots: { customRender: 'name' } },
  { title: 'Vendor Sign', dataIndex: 'vendorSign', key: 'vendorSign' },
  { title: 'Vendor Email', dataIndex: 'email', key: 'email' },
  { title: 'PIC', dataIndex: 'PIC', key: 'PIC' },
  { title: 'Mobile Number', dataIndex: 'mobileNumber', key: 'mobileNumber' },
]

export default {
  components: {
    PlusOutlined,
    RestOutlined,
  },

  setup() {
    const data = ref([])
    const search = ref('')
    const loading = ref(false)

    // State untuk mengontrol modal
    const isDeleteModalVisible = ref(false)
    const vendorIdToDelete = ref(null)
    const role = ref('')
    // Fungsi untuk mengambil data vendor
    const fetchVendors = async (searchTerm = '') => {
      const storedUserData = localStorage.getItem('userData')
      const userData = JSON.parse(storedUserData)
      role.value = userData.user.role
      loading.value = true
      try {
        const { vendor } = await getVendors(searchTerm)
        data.value = vendor.map((v, index) => ({
          ...v,
          key: index + 1,
        }))
      } catch (error) {
        console.error('Gagal mengambil data vendor:', error)
        notification.error({
          message: 'Gagal Memuat Data',
          description: 'Terjadi kesalahan saat mengambil daftar vendor.',
        })
      } finally {
        loading.value = false
      }
    }

    // Panggil saat komponen dimuat
    onMounted(fetchVendors)

    // Panggil saat ada pencarian
    watch(search, newValue => {
      fetchVendors(newValue)
    })

    // Fungsi utama untuk menghapus vendor
    const deleteVendorFunc = async vendorId => {
      try {
        await deleteVendor(vendorId)
        notification.success({
          message: 'Berhasil',
          description: 'Vendor telah berhasil dihapus.',
        })
        await fetchVendors() // Muat ulang daftar setelah sukses
      } catch (error) {
        console.error('Gagal menghapus vendor:', error)
        const errorMsg =
          error.response?.data?.message || 'Terjadi kesalahan saat mencoba menghapus vendor.'
        notification.error({
          message: 'Gagal Menghapus',
          description: errorMsg,
        })
      }
    }

    // Fungsi untuk membuka modal
    const openDeleteModal = vendorId => {
      vendorIdToDelete.value = vendorId
      isDeleteModalVisible.value = true
    }

    // Fungsi untuk menutup modal
    const closeDeleteModal = () => {
      isDeleteModalVisible.value = false
      vendorIdToDelete.value = null
    }

    // Fungsi yang dipanggil saat tombol OK modal ditekan
    const handleDelete = () => {
      if (vendorIdToDelete.value) {
        deleteVendorFunc(vendorIdToDelete.value)
      }
      closeDeleteModal()
    }

    return {
      data,
      columns,
      search,
      loading,
      isDeleteModalVisible,
      openDeleteModal,
      closeDeleteModal,
      handleDelete,
      role,
      columnsDcOwner,
    }
  },
}
</script>
